//处理字符串
export function handleChara(text, num) {
  if (!text) return ""
  if (text.length > num) {
    return text.slice(0, num) + '...';
  } else {
    return text
  }
}
export const newExperienceList = {
  0: '不限',
  1: '一年以内',
  2: '1-3年',
  3: '3-5年',
  4: '5-10年',
  5: '10年以上'
}
export const newQualificationList = {
  0: '不限',
  1: '初中及以下',
  2: '中专/中技',
  3: '高中',
  4: '大专',
  5: '本科',
  6: '硕士',
  7: '博士'
}

export function extractCityFromAddress(address) {
  // 省级行政区列表（按长度倒序排列，确保先匹配更长的名称）
  const provinces = [
    "内蒙古自治区", "广西壮族自治区", "西藏自治区", "宁夏回族自治区", "新疆维吾尔自治区",
    "黑龙江省", "贵州省", "云南省", "四川省", "陕西省", "甘肃省", "湖南省", "湖北省", "河南省", "河北省",
    "山东省", "山西省", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "广东省", "海南省", "吉林省", "辽宁省", "青海省",
    "北京市", "天津市", "上海市", "重庆市", "香港特别行政区", "澳门特别行政区",
    "内蒙古", "广西", "西藏", "宁夏", "新疆",
    "北京", "天津", "上海", "重庆", "香港", "澳门"
  ];

  // 直辖市列表
  const municipalities = ["北京", "天津", "上海", "重庆"];

  let foundProvince = "";
  let remainingAddress = address;

  // 查找并移除省级行政区
  for (const province of provinces) {
    if (address.startsWith(province)) {
      foundProvince = province;
      remainingAddress = address.slice(province.length);
      break;
    }
  }

  // 如果是直辖市，直接返回直辖市名称
  for (const municipality of municipalities) {
    if (foundProvince.includes(municipality)) {
      return municipality;
    }
  }
  // 在剩余地址中查找"市"
  const cityIndex = remainingAddress.indexOf("市");
  if (cityIndex !== -1) {
    // 从开头到"市"之间的部分就是城市名称
    let cityName = remainingAddress.substring(0, cityIndex);

    // 处理一些特殊情况
    if (cityName === "") {
      // 如果省级行政区后直接跟着"市"（如"北京市"已经被截取）
      return foundProvince.replace("省", "").replace("自治区", "").replace("特别行政区", "");
    }
    return cityName;
  }
  // 如果没有找到"市"，尝试其他方式或返回空
  return null;
}
